/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import styles from '../../../styles/fields/checkbox.module.scss';

const propTypes = {
    id: PropTypes.string,
    label: PropTypes.node,
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    className: PropTypes.string,
    onChange: PropTypes.func,
};

const defaultProps = {
    id: 'checkbox',
    name: null,
    label: 'text',
    value: null,
    className: null,
    onChange: null,
};

const CheckboxField = ({ id, name, label, value, onChange, className }) => {
    const onInputChange = useCallback(() => {
        if (onChange !== null) {
            onChange(!value);
        }
    }, [onChange, value]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <input id={id} name={name} type="checkbox" checked={!!value} onChange={onInputChange} />
            <label htmlFor={id}>{label}</label>
        </div>
    );
};

CheckboxField.propTypes = propTypes;
CheckboxField.defaultProps = defaultProps;

export default CheckboxField;
